export default __webpack_public_path__ + "static/media/ic-planet.c9566dfa.svg";